import { PageModule, PageModuleData } from '@/types'
import {
  GetterTree, Module, MutationTree, ActionTree,
} from 'vuex'

export interface PageModulesState {
  listResult: PageModule<PageModuleData>[]
  listEnd: PageModule<PageModuleData>[]
  listChart: PageModule<PageModuleData>[]
}

const pageModulesState: PageModulesState = {
  listResult: [],
  listEnd: [],
  listChart: [],
}

const mutations: MutationTree<PageModulesState> = {
  SET_PAGE_MODULES_LIST_RESULT (state: PageModulesState, listResult) {
    state.listResult = listResult
  },
  SET_PAGE_MODULES_LIST_END (state: PageModulesState, listEnd) {
    state.listEnd = listEnd
  },
  SET_PAGE_MODULES_LIST_CHART (state: PageModulesState, listChart) {
    state.listChart = listChart
  },
}

const actions: ActionTree<PageModulesState, any> = {}

const getters: GetterTree<PageModulesState, any> = {
  pageModulesListResult: (state: PageModulesState) => state.listResult,
  pageModulesListEnd: (state: PageModulesState) => state.listEnd,
  pageModulesListChart: (state: PageModulesState) => state.listChart,
}

export const pageModulesModule: Module<PageModulesState, any> = {
  state: pageModulesState,
  mutations,
  actions,
  getters,
}
